import { i18n } from '../../i18n.config';
import en from './en.json';
import ru from './ru.json';

i18n.addResourceBundle('en', 'steam-settings', en, true);
i18n.addResourceBundle('ru', 'steam-settings', ru, true);
